import { jsxs as u, Fragment as G, jsx as e } from "react/jsx-runtime";
import { useState as C, useRef as ce, useCallback as x, useEffect as N, useLayoutEffect as de, memo as ue, useMemo as ge, StrictMode as pe } from "react";
import { C as Q, I as he, t as me, J as fe, R as ve } from "./FormView-CWSNCHG6.js";
import { z as V, y as ye, x as be, o as Le, k as _e, r as we, v as Se } from "./fetcher-CUYp7JR1.js";
import { Typography as Be, Alert as Ce, Flex as L, Button as E, Progress as Re, ConfigProvider as ke, App as Ne, Grid as Me, Image as He, Menu as Ie, Dropdown as xe } from "antd";
import { f as D } from "./templateResolver-BchYA4i9.js";
import "./use-definition-0yWcQDPI.js";
import "idb";
import { j as Ae, k as W } from "./DataGrid-Cy1qOpyR.js";
import { a as J } from "./loading-status-Bznbx7a4.js";
import { QueryClientProvider as Te } from "@tanstack/react-query";
import { createRoot as Pe } from "react-dom/client";
import { redirect as Y, createRootRoute as Ee, createRoute as b, createRouter as Ge, Outlet as Z, useLocation as ze, Link as X } from "@tanstack/react-router";
import { T as Oe, L as $e } from "./TabListView-DTlHiJjA.js";
import { LogoutOutlined as q, MenuOutlined as K, DashboardOutlined as je, MessageOutlined as De, BarChartOutlined as Ue, CalendarOutlined as Fe, TeamOutlined as Ve, SettingOutlined as We } from "@ant-design/icons";
function I(t, r, i) {
  const s = t.replace(/\/$/, "") || "/";
  return s === "/forgot-password" && r ? "forgot" : s === "/reset-password" && i ? "reset" : "login";
}
function oo({
  children: t,
  LoginComponent: r,
  TwoFAComponent: i,
  ForgotPasswordComponent: s,
  ResetPasswordComponent: o,
  LoadingComponent: l = null,
  setLoggedIn: d
}) {
  const [a, f] = C(!1), [g, c] = C(!0), [n, v] = C(!1), [M, S] = C(null), [h, B] = C([]), [y, R] = C(
    () => I(
      typeof window < "u" ? window.location.pathname : "/",
      !!s,
      !!o
    )
  ), [U, oe] = C(0), re = V((m) => m.setLoggedIn), k = d || re, A = V((m) => m.loggedIn), z = a && A, F = ce(null), T = x(() => {
    oe((m) => m + 1);
  }, []), O = x(
    (m) => {
      window.history.pushState(null, "", m);
      const H = new URL(window.location.href);
      R(
        I(
          H.pathname,
          !!s,
          !!o
        )
      ), T();
    },
    [s, o, T]
  ), ne = x(() => {
    Q(), k(!1), f(!1);
  }, [k]);
  N(() => {
    const m = () => {
      R(
        I(
          window.location.pathname,
          !!s,
          !!o
        )
      ), T();
    };
    return window.addEventListener("popstate", m), () => {
      window.removeEventListener("popstate", m);
    };
  }, [s, o, T]), N(() => {
    !a && !g && !n && R(
      I(
        window.location.pathname,
        !!s,
        !!o
      )
    );
  }, [
    a,
    g,
    n,
    s,
    o
  ]), N(() => {
    !z && !g && !n && ye(be);
  }, [z, g, n]), N(() => {
    const m = F.current;
    F.current = A, !A && (f(!1), m === !0 && (Le(), typeof window < "u" && window.history.replaceState(null, "", "/")));
  }, [A]), N(() => {
    (async () => {
      c(!0);
      const H = await he();
      c(!1), H ? (f(!0), k(!0)) : (f(!1), k(!1));
    })();
  }, [k]);
  const ae = async (m, H) => {
    const $ = await me({ username: m, password: H });
    fe($) ? (v(!0), S($.challenge_token), B($.methods)) : (f(!0), k(!0));
  }, ie = () => {
    v(!1), S(null), B([]), f(!0), k(!0);
  }, se = () => {
    v(!1), S(null), B([]);
  }, le = typeof window < "u" ? window.location.pathname : "/", P = !g && !n && !!o && I(
    le,
    !!s,
    !!o
  ) === "reset";
  return /* @__PURE__ */ u(G, { children: [
    g && l,
    !g && !n && P && o && /* @__PURE__ */ e(
      o,
      {
        token: new URLSearchParams(window.location.search).get(
          "token"
        ),
        onNavigateLogin: () => {
          O("/");
        },
        onResetSessionInvalidate: ne
      }
    ),
    !g && !a && !n && !P && y === "login" && r && /* @__PURE__ */ e(
      r,
      {
        onLogin: ae,
        ...s ? {
          onForgotPassword: () => {
            O(
              "/forgot-password"
            );
          }
        } : {}
      }
    ),
    !g && !a && !n && !P && y === "forgot" && s && /* @__PURE__ */ e(
      s,
      {
        onNavigateLogin: () => {
          O("/");
        }
      }
    ),
    !g && !a && n && i && M && /* @__PURE__ */ e(
      i,
      {
        challengeToken: M,
        methods: h,
        onVerified: ie,
        onCancel: se
      }
    ),
    !g && z && !n && !P && t
  ] });
}
function Xe() {
  return de(() => {
    const t = "ant-font-override";
    if (document.getElementById(t))
      return;
    const r = document.createElement("style");
    return r.id = t, r.textContent = `
:root {
	--ant-font-family: "Soehne", sans-serif;
	--ant-font-family-code: "Soehne", monospace;
}`, document.head.appendChild(r), () => {
      var i;
      (i = document.getElementById(t)) == null || i.remove();
    };
  }, []), null;
}
const qe = "_error_lnyw9_1", Ke = "_loading_lnyw9_1", Qe = "_innerContainer_lnyw9_25", Je = "_loaderLogo_lnyw9_38", Ye = "_spinner_lnyw9_48", Ze = "_spinnerRing_lnyw9_55", et = "_title_lnyw9_67", tt = "_subtitle_lnyw9_77", ot = "_progressBlock_lnyw9_86", rt = "_progressMeta_lnyw9_92", nt = "_progressLabel_lnyw9_99", at = "_progressPercent_lnyw9_106", it = "_progressBar_lnyw9_115", st = "_stepList_lnyw9_132", lt = "_stepItem_lnyw9_141", ct = "_alertPanel_lnyw9_150", dt = "_actions_lnyw9_157", p = {
  error: qe,
  loading: Ke,
  innerContainer: Qe,
  loaderLogo: Je,
  spinner: Ye,
  spinnerRing: Ze,
  title: et,
  subtitle: tt,
  progressBlock: ot,
  progressMeta: rt,
  progressLabel: nt,
  progressPercent: at,
  progressBar: it,
  stepList: st,
  stepItem: lt,
  alertPanel: ct,
  actions: dt
}, { Text: w } = Be, ee = ({
  children: t,
  className: r
}) => /* @__PURE__ */ e("div", { className: r, children: /* @__PURE__ */ e("div", { className: p.innerContainer, children: /* @__PURE__ */ e(L, { vertical: !0, align: "center", gap: "middle", style: { width: "100%" }, children: t }) }) });
function ut() {
  return /* @__PURE__ */ e(
    "img",
    {
      src: "/logo.png",
      alt: "HCA",
      className: p.loaderLogo
    }
  );
}
function gt() {
  return /* @__PURE__ */ e("div", { className: p.spinner, "aria-hidden": !0, children: /* @__PURE__ */ e("span", { className: p.spinnerRing }) });
}
const pt = ({ items: t }) => {
  const r = D(), i = t.filter((a) => a.status === "loading"), s = t.filter((a) => a.status === "success"), o = Math.max(t.length, 1), l = Math.round(s.length / o * 100), d = i.length > 0 ? "Loading..." : null;
  return /* @__PURE__ */ u(ee, { className: p.loading, children: [
    /* @__PURE__ */ e(ut, {}),
    /* @__PURE__ */ e(gt, {}),
    /* @__PURE__ */ u(w, { className: p.title, children: [
      "Loading ",
      r.appName
    ] }),
    /* @__PURE__ */ e(w, { className: p.subtitle, children: "Preparing your workspace securely" }),
    /* @__PURE__ */ u("div", { className: p.progressBlock, children: [
      /* @__PURE__ */ u("div", { className: p.progressMeta, children: [
        /* @__PURE__ */ u(w, { className: p.progressLabel, children: [
          s.length,
          " of ",
          t.length,
          " ready"
        ] }),
        /* @__PURE__ */ u(w, { className: p.progressPercent, children: [
          l,
          "%"
        ] })
      ] }),
      /* @__PURE__ */ e(
        Re,
        {
          className: p.progressBar,
          percent: l,
          showInfo: !1,
          size: ["100%", 6]
        }
      )
    ] }),
    d && /* @__PURE__ */ e("div", { className: p.stepList, children: /* @__PURE__ */ e(w, { className: p.stepItem, children: d }) })
  ] });
}, ht = ({ errorItems: t }) => {
  var o;
  const r = D(), i = t.some(
    (l) => Ae(l.error)
  ), s = t.length === 1 ? W((o = t[0]) == null ? void 0 : o.error) : "Some required components failed to load.";
  return /* @__PURE__ */ u(ee, { className: p.error, children: [
    /* @__PURE__ */ e(
      Ce,
      {
        type: "error",
        showIcon: !0,
        className: p.alertPanel,
        title: "Unable to load application",
        description: /* @__PURE__ */ u(L, { vertical: !0, gap: "small", style: { textAlign: "left" }, children: [
          /* @__PURE__ */ u(w, { children: [
            r.appName,
            " could not finish loading."
          ] }),
          /* @__PURE__ */ e(w, { children: s }),
          t.length > 0 && /* @__PURE__ */ u(L, { vertical: !0, gap: 4, style: { marginTop: 4 }, children: [
            /* @__PURE__ */ e(w, { type: "secondary", style: { fontSize: 12 }, children: "Details" }),
            t.map((l) => {
              const d = W(
                l.error
              ), a = l.error || "";
              return /* @__PURE__ */ u(
                w,
                {
                  type: "secondary",
                  style: { fontSize: 12 },
                  children: [
                    l.name,
                    ": ",
                    d,
                    a && a !== d ? ` (${a})` : ""
                  ]
                },
                l.id
              );
            })
          ] }),
          /* @__PURE__ */ e(
            w,
            {
              type: "secondary",
              style: { fontSize: 14, marginTop: 8 },
              children: "Refresh the page to try again. If this keeps happening, contact your system administrator."
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ u(
      L,
      {
        justify: i ? "space-between" : "center",
        gap: "middle",
        className: p.actions,
        children: [
          /* @__PURE__ */ e(
            E,
            {
              type: i ? "default" : "primary",
              onClick: () => {
                window.location.reload();
              },
              children: "Refresh Page"
            }
          ),
          i && /* @__PURE__ */ e(
            E,
            {
              type: "primary",
              onClick: () => {
                window.location.href = "/";
              },
              children: "Sign In"
            }
          )
        ]
      }
    )
  ] });
};
function mt({ children: t }) {
  const { isSuccess: r } = J();
  return /* @__PURE__ */ u(G, { children: [
    !r && /* @__PURE__ */ e(ft, {}),
    /* @__PURE__ */ e("div", { style: { display: r ? "block" : "none" }, children: t })
  ] });
}
function ft({
  loadingComponent: t = pt,
  errorComponent: r = ht
}) {
  const { items: i, isLoading: s, hasError: o, errorItems: l } = J();
  return /* @__PURE__ */ u(G, { children: [
    o && /* @__PURE__ */ e(r, { errorItems: l }),
    !o && s && /* @__PURE__ */ e(t, { items: i })
  ] });
}
function ro({
  children: t,
  guards: r = [],
  onLoad: i = () => {
  }
}) {
  const s = ge(() => new AbortController(), []), [o, l] = C(0), d = x(
    () => () => {
      l((a) => Math.min(r.length, a + 1));
    },
    []
  );
  return N(() => {
    o === r.length && i();
  }, [o]), /* @__PURE__ */ u(mt, { children: [
    r.map((a) => /* @__PURE__ */ e(
      te,
      {
        guard: a,
        onSuccess: d(),
        abortController: s
      },
      a.name
    )),
    o === r.length && t
  ] });
}
const te = ue(
  ({
    guard: t,
    onSuccess: r,
    abortController: i
  }) => {
    const o = x(
      () => t(i.signal),
      [t]
    )();
    return N(() => {
      (async () => {
        var d, a, f, g;
        try {
          const c = o.execute();
          if (o.error)
            throw (d = o.status) == null || d.setError(o.error.message), new Error(o.error.message);
          if ((a = o.status) == null || a.setLoading("Loading..."), o.isLoading || o.isValidating || !c.success && !c.error)
            return;
          if (!c.success || c.error)
            throw (f = o.status) == null || f.setError(`${c.error}`), new Error(c.error);
          (g = o.status) == null || g.setSuccess(
            `${o.description} loaded successfully`
          ), r();
        } catch (c) {
          i.abort(
            new Error(
              `Interrupted due to ${c.message || "unknown error"}`
            )
          );
        }
      })();
    }, [o.description, o.data, o.error]), /* @__PURE__ */ e(G, {});
  }
);
te.displayName = "AuthGuardRunnerItem";
function vt({ children: t, client: r }) {
  return /* @__PURE__ */ e(Te, { client: r ?? _e, children: t });
}
const yt = {
  hashed: !1,
  token: {
    // Colors - these will be overridden by CSS variables
    colorPrimary: "var(--color-primary)",
    colorSuccess: "var(--color-success)",
    colorWarning: "var(--color-warning)",
    colorError: "var(--color-error-500)",
    colorInfo: "var(--color-info)",
    // Text colors
    colorText: "var(--color-text-700)",
    colorTextSecondary: "var(--color-text-500)",
    colorTextTertiary: "var(--color-text-400)",
    colorTextQuaternary: "var(--color-text-300)",
    colorTextLightSolid: "var(--white)",
    // Background colors
    colorBgContainer: "var(--white)",
    colorBgElevated: "var(--white)",
    colorBgLayout: "var(--color-background-200)",
    // Border colors
    colorBorder: "var(--color-border-200)",
    colorBorderSecondary: "var(--color-border-100)",
    borderRadius: 8,
    borderRadiusLG: 10,
    borderRadiusSM: 8,
    borderRadiusXS: 6,
    fontFamily: '"Soehne", sans-serif',
    fontSize: 14,
    fontSizeHeading1: 38,
    fontSizeHeading2: 30,
    fontSizeHeading3: 24,
    fontSizeHeading4: 20,
    fontSizeHeading5: 16,
    // Line height
    lineHeight: 1.5715,
    lineHeightHeading1: 1.21,
    lineHeightHeading2: 1.27,
    lineHeightHeading3: 1.33,
    lineHeightHeading4: 1.4,
    lineHeightHeading5: 1.5,
    // Control heights (aligned with --ui-button-control-height* in semantic-tokens.scss)
    controlHeight: 36,
    controlHeightLG: 44,
    controlHeightSM: 28,
    // Spacing
    padding: 16,
    paddingLG: 24,
    paddingMD: 20,
    paddingSM: 12,
    paddingXS: 8,
    paddingXXS: 4,
    margin: 16,
    marginLG: 24,
    marginMD: 20,
    marginSM: 12,
    marginXS: 8,
    marginXXS: 4
  },
  components: {
    /**
     * Button surface: `--ui-button-3d-*` + `--ui-button-surface-radius` in `semantic-tokens.scss` (no pedestal bar);
     * hover: translateY only, no box-shadow; active: inset shadow in `antd-theme-components.scss`.
     */
    Button: {
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 28,
      fontWeight: 500,
      iconGap: 5,
      defaultShadow: "var(--ui-button-3d-shadow-default)",
      primaryShadow: "var(--ui-button-3d-shadow-primary)",
      dangerShadow: "var(--ui-button-3d-shadow-danger-solid)",
      primaryColor: "var(--color-primary)",
      dangerColor: "var(--color-error-500)",
      defaultColor: "var(--color-text-700)",
      defaultBg: "var(--white)",
      defaultBorderColor: "var(--color-border-200)",
      defaultHoverBg: "var(--white)",
      defaultHoverColor: "var(--color-text-700)",
      defaultHoverBorderColor: "var(--color-primary-400)",
      defaultActiveBg: "var(--white)",
      defaultActiveColor: "var(--color-text-700)",
      defaultActiveBorderColor: "var(--color-primary-700)",
      defaultGhostColor: "var(--white)",
      ghostBg: "transparent",
      defaultGhostBorderColor: "var(--white)",
      textTextColor: "var(--color-text-700)",
      textTextHoverColor: "var(--color-primary-400)",
      textTextActiveColor: "var(--color-primary-700)",
      linkHoverBg: "transparent",
      textHoverBg: "var(--color-background-200)",
      paddingInline: 12,
      paddingInlineLG: 14,
      paddingInlineSM: 12,
      paddingBlock: 8,
      paddingBlockLG: 12,
      paddingBlockSM: 5,
      contentFontSize: 14,
      contentFontSizeLG: 14,
      contentFontSizeSM: 12,
      contentLineHeight: 1.4285714285714286,
      contentLineHeightLG: 1.4285714285714286,
      contentLineHeightSM: 1.5,
      defaultBgDisabled: "var(--ui-button-disabled-default-bg)",
      dashedBgDisabled: "var(--ui-button-disabled-default-bg)",
      borderColorDisabled: "var(--color-border-200)"
    },
    Input: {
      // Inputs will use CSS variables
      controlHeight: 44,
      controlHeightLG: 52,
      controlHeightSM: 36
    },
    Select: {
      // Selects will use CSS variables
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 28
    },
    DatePicker: {
      controlHeight: 36,
      controlHeightLG: 44,
      controlHeightSM: 28,
      cellActiveWithRangeBg: "var(--color-primary-50)",
      cellHoverBg: "var(--color-primary-50)",
      activeBorderColor: "var(--color-primary)",
      hoverBorderColor: "var(--color-primary-300)"
    },
    Table: {
      borderColor: "var(--table-border-color)",
      headerBg: "var(--table-header-bg)",
      headerColor: "var(--table-header-text)",
      rowHoverBg: "var(--table-row-hover-bg)",
      cellFontSize: 13,
      cellPaddingBlock: 12,
      cellPaddingInline: 16,
      headerSplitColor: "transparent"
    },
    Card: {
      borderRadiusLG: 16
    },
    Modal: {
      borderRadiusLG: 16
    },
    Drawer: {
      borderRadiusLG: 16
    },
    Message: {
      borderRadiusLG: 16
    },
    Notification: {
      borderRadiusLG: 16
    },
    Alert: {
      borderRadiusLG: 16,
      colorInfoBg: "var(--color-info-50)",
      colorInfoBorder: "var(--color-info-200)",
      colorSuccessBg: "var(--color-success-50)",
      colorSuccessBorder: "var(--color-success-200)",
      colorWarningBg: "var(--color-warning-50)",
      colorWarningBorder: "var(--color-warning-200)",
      colorErrorBg: "var(--color-error-50)",
      colorErrorBorder: "var(--color-error-200)"
    },
    Tabs: {
      // Pill-style tabs: container + selected tab with elevation
      itemColor: "var(--color-text-600)",
      itemSelectedColor: "var(--white)",
      itemHoverColor: "var(--color-text-800)",
      inkBarColor: "transparent",
      titleFontSize: 14,
      titleFontSizeLG: 16
    }
  }
};
function bt({ children: t }) {
  return /* @__PURE__ */ e(ke, { theme: yt, children: /* @__PURE__ */ u(Ne, { children: [
    /* @__PURE__ */ e(Xe, {}),
    t
  ] }) });
}
function Lt(t, r) {
  D.getState().set(t);
  const i = document.getElementById("root");
  i ? Pe(i).render(
    /* @__PURE__ */ e(_t, { children: r })
  ) : console.error("Root element not found");
}
const no = Lt;
function _t({ children: t }) {
  return /* @__PURE__ */ e(pe, { children: /* @__PURE__ */ e(vt, { children: /* @__PURE__ */ e(bt, { children: t }) }) });
}
function wt() {
  return we() === Se ? "/pbm-portal/patient" : "/dashboard";
}
function St(t) {
  if (ve(t))
    return;
  const r = wt();
  if (t !== r)
    throw Y({ to: r, replace: !0 });
}
const Bt = (t) => {
  St(t);
};
function Ct() {
  return /* @__PURE__ */ e(Z, {});
}
function ao(t) {
  const {
    rootLayout: r,
    simpleRoutes: i,
    nestedModules: s,
    defaultRedirect: o = "/dashboard",
    beforeLoad: l = Bt
  } = t, d = Ee({
    component: r
  }), a = b({
    getParentRoute: () => d,
    path: "/",
    beforeLoad: () => {
      throw Y({ to: o });
    }
  }), f = i.flatMap(
    (n) => {
      if (!n.pathParam)
        return [
          b({
            getParentRoute: () => d,
            path: n.path,
            component: n.component,
            beforeLoad: ({ location: h }) => {
              l(h.pathname);
            }
          })
        ];
      const v = b({
        getParentRoute: () => d,
        path: n.path,
        component: Ct,
        beforeLoad: ({ location: h }) => {
          l(h.pathname);
        }
      }), M = b({
        getParentRoute: () => v,
        path: "/",
        component: n.component,
        beforeLoad: ({ location: h }) => {
          l(h.pathname);
        }
      }), S = b({
        getParentRoute: () => v,
        path: `$${n.pathParam}`,
        component: n.component,
        beforeLoad: ({ location: h }) => {
          l(h.pathname);
        }
      });
      return [v.addChildren([M, S])];
    }
  ), g = s.map((n) => {
    const v = b({
      getParentRoute: () => d,
      path: n.path,
      component: n.layout,
      beforeLoad: ({ location: y }) => {
        l(y.pathname);
      }
    }), M = n.listComponent ?? (() => /* @__PURE__ */ e(
      Oe,
      {
        ...n.componentProps ?? {},
        entity: n.entity,
        basePath: n.path,
        paramName: n.paramName,
        entityColOverride: n.entityColOverride,
        customColumnDefs: n.customColumnDefs,
        customColumnDefsPosition: n.customColumnDefsPosition,
        toolbarExtra: n.toolbarExtra
      }
    )), S = b({
      getParentRoute: () => v,
      path: "/",
      component: M
    }), h = b({
      getParentRoute: () => v,
      path: `$${n.paramName}`,
      component: n.detail
    }), B = [];
    if (n.subRoutes && n.subRoutes.length > 0)
      for (const y of n.subRoutes) {
        const R = y.listComponent ?? (() => /* @__PURE__ */ e(
          $e,
          {
            entity: y.entity,
            scope: `${n.entity}-${y.path}`,
            ...y.componentProps ?? {}
          }
        ));
        B.push(
          b({
            getParentRoute: () => h,
            path: y.path,
            component: R
          })
        );
      }
    if (n.detailChildren) {
      const {
        listComponent: y,
        detailComponent: R,
        paramName: U
      } = n.detailChildren;
      B.push(
        b({
          getParentRoute: () => h,
          path: "/",
          component: y
        }),
        b({
          getParentRoute: () => h,
          path: `$${U}`,
          component: R
        })
      );
    }
    return B.length > 0 ? v.addChildren([
      S,
      h.addChildren(B)
    ]) : v.addChildren([S, h]);
  }), c = d.addChildren([
    a,
    ...f,
    ...g
  ]);
  return Ge({ routeTree: c });
}
const Rt = "_root_1fch9_1", kt = "_main_1fch9_6", Nt = "_content_1fch9_12", j = {
  root: Rt,
  main: kt,
  content: Nt
}, Mt = "_container_kmj46_1", Ht = "_logo_kmj46_14", It = "_logoLink_kmj46_19", xt = "_logoImage_kmj46_35", At = "_menu_kmj46_49", Tt = "_desktopMenu_kmj46_137", Pt = "_logoutButton_kmj46_141", Et = "_mobileMenuTrigger_kmj46_145", Gt = "_mobileMenuOverlay_kmj46_153", zt = "_actions_kmj46_174", _ = {
  container: Mt,
  logo: Ht,
  logoLink: It,
  logoImage: xt,
  menu: At,
  desktopMenu: Tt,
  logoutButton: Pt,
  mobileMenuTrigger: Et,
  mobileMenuOverlay: Gt,
  actions: zt
}, Ot = [
  { name: "Dashboard", path: "/dashboard", icon: /* @__PURE__ */ e(je, {}) },
  { name: "Chat", path: "/chat", icon: /* @__PURE__ */ e(De, {}) },
  { name: "Analytics", path: "/analytics", icon: /* @__PURE__ */ e(Ue, {}) },
  { name: "Plan", path: "/plan", icon: /* @__PURE__ */ e(Fe, {}) },
  { name: "Member", path: "/patient", icon: /* @__PURE__ */ e(Ve, {}) },
  { name: "Manage", path: "/settings", icon: /* @__PURE__ */ e(We, {}) }
];
function $t({
  navModules: t = Ot,
  logoTitle: r = "HCA",
  logoSrc: i = "/logo.png"
}) {
  const o = !Me.useBreakpoint().lg, l = () => {
    Q();
  }, d = ze(), a = t.find(
    (c) => d.pathname.startsWith(c.path)
  ), f = t.map(
    (c) => ({
      key: c.name,
      icon: c.icon,
      label: /* @__PURE__ */ e(X, { to: c.path, children: c.name })
    })
  ), g = [
    ...f,
    { type: "divider" },
    {
      key: "logout",
      icon: /* @__PURE__ */ e(q, {}),
      label: "Logout",
      danger: !0
    }
  ];
  return /* @__PURE__ */ u(
    L,
    {
      align: "center",
      justify: "space-between",
      className: _.container,
      children: [
        /* @__PURE__ */ e(L, { align: "center", className: _.logo, children: /* @__PURE__ */ e(
          X,
          {
            to: "/dashboard",
            "aria-label": `${r} — go to dashboard`,
            className: _.logoLink,
            children: /* @__PURE__ */ e(
              He,
              {
                alt: r,
                className: _.logoImage,
                preview: !1,
                src: i
              }
            )
          }
        ) }),
        /* @__PURE__ */ e(
          L,
          {
            flex: 1,
            align: "center",
            justify: "center",
            className: _.menu,
            children: !o && /* @__PURE__ */ e(L, { className: _.desktopMenu, children: /* @__PURE__ */ e(
              Ie,
              {
                mode: "horizontal",
                selectedKeys: a ? [a.name] : [],
                overflowedIndicator: /* @__PURE__ */ e(K, {}),
                items: f
              }
            ) })
          }
        ),
        /* @__PURE__ */ u(L, { className: _.actions, gap: 12, align: "center", children: [
          !o && /* @__PURE__ */ e(
            E,
            {
              className: _.logoutButton,
              icon: /* @__PURE__ */ e(q, {}),
              onClick: l,
              type: "primary",
              danger: !0,
              children: "Logout"
            }
          ),
          o && /* @__PURE__ */ e(
            xe,
            {
              overlayClassName: _.mobileMenuOverlay,
              placement: "bottomRight",
              trigger: ["click"],
              menu: {
                items: g,
                selectable: !0,
                selectedKeys: a ? [a.name] : [],
                onClick: ({
                  key: c
                }) => {
                  c === "logout" && l();
                }
              },
              children: /* @__PURE__ */ e(
                E,
                {
                  className: _.mobileMenuTrigger,
                  icon: /* @__PURE__ */ e(K, {}),
                  "aria-label": "Open mega menu"
                }
              )
            }
          )
        ] })
      ]
    }
  );
}
function io({ topBarProps: t } = {}) {
  return /* @__PURE__ */ u(L, { vertical: !0, className: j.root, children: [
    /* @__PURE__ */ e($t, { ...t }),
    /* @__PURE__ */ e(L, { className: j.main, children: /* @__PURE__ */ e("div", { className: j.content, children: /* @__PURE__ */ e(Z, {}) }) })
  ] });
}
export {
  ro as A,
  no as C,
  vt as F,
  mt as L,
  Lt as N,
  io as R,
  $t as T,
  bt as U,
  _t as a,
  oo as b,
  ao as c,
  Xe as d,
  St as e
};
